export const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') {
      number = Number(number); // Convert string to number if needed
      if (isNaN(number)) return '-'; // Return empty string if conversion fails
  }
  return number.toLocaleString();
};
